export const LANG_EN_NAME = 'en-US';

export const LANG_EN_TRANS = {
    "SeparadorMilhar": ",",
    "SeparadorDecimal": ".",
    "FormatoDataCampo": "mm/dd/yy",
    "ErroAplicacao": "An error has ocurred in the application",
    "ErroAplicacao_Mensagem": "An error happened during your request. Please try again, and if it persists contact system's responsable.",
    "ErroAplicacao_Descricao": "Error description",
    "Pesquisa": "Filters",
    "Selecione": "Select",
    "Pesquisar": "Search",
    "Sim": "Yes",
    "Nao": "No",
    "Acao": "Action",
    "Novo": "New",
    "Salvar": "Save",
    "ValidarErro": "Alerts",
    "Cancelar": "Cancel",
    "Manutencao": "Maintenance",
    "Voltar": "Back",
    "NomeSistema":"Won Internet Banking",
    "Operador":"Operador",
    "Codigo":"Code",
    "Nome":"Name",
    "Login":"Login",
    "Email":"E-mail",
    "IdentificadorPerfil":"Profile Identifier",
    "Ativo":"Active",
    "HorarioOperacao":"Operating Hours",
    "TipoTributo":"Type Tribute",
    "TipoOperacao":"Operation Type",
    "HorarioInicial":"Starttime",
    "HorarioFinal":"FinalTime",
    "ApenasDiaUtil":"Business Day",
    "ConfirmarExclusaoOperacaoHorario":"Are you sure you want to delete the time?",
    "ConfirmarExclusaoOperador":"Are you sure you want to delete the operator?",
    "Excluir":"Delete record",
    "PrecisaAjuda":"Need Help?",
    "TelefoneAjuda":"+55 11 3511-3389",
    "Transferencias":"Transfers",
    "Pagamentos":"Payments",
    "Extrato":"Extract",
    "Pix":"Pix",
    "Investimentos":"Investments",
    "AprovacaoOperacao":"Operation Approval",
    "Tributos":"Tributes",
    "UploadArquivo":"Upload File",
    "Administracao":"Administration",
    "TrocarSenha":"Change Password",
    "GerarToken":"Generate Token",
    "Liberar":"Release",
    "Monitor":"Monitor",
    "Atalhos":"Shortcuts",
    "SaldoDisponivel":"Available Balance",
    "SaldoTotal":"Total Balance",
    "SaldoBloqueado":"Blocked Balance",
    "PesquisarExtrato":"Search Extract",
    "De":"From",
    "Ate":"Until",
    "LancamentosFuturos":"Future Releases",
    "LancamentosEfetivados":"Effective Launchings",
    "PosicaoInvestimento":"Investment Position",
    "TotalLiquido":"Total Net Amount",
    "DataPosicao":"Date Position",
    "AplicacaoDe":"Application From",
    "AplicacaoAte":"Application Until",
    "VencimentoDe":"Expiration From",
    "VencimentoAte":"Expiration Until",
    "PesquisarInvestimento":"Search Investment",
    "Aplicacao":"Application",
    "Vencimento":"Maturity",
    "Papel":"Paper",
    "Nota":"Note",
    "ValorAplicado":"Applied Amount",
    "SaldoBruto":"Gross Balance",
    "SaldoLiquido":"Net Balance",
    "Impostos":"Taxes",
    "ArrasteArquivo":"Drag the file to upload",
    "AddArquivoComputador":"Select file from computer",
    "PosicaoInvestimentoSemDados":"There is no investment position for the informed date",
    "InfomarToken":"Enter the Confirmation Token",
    "Contraparte":"Counterparty",
    "ExtratoConta":"Account Statement",
    "ScanearQRCode":"Scan the QRCode below on your favorite authentication system",
    "InformeTokenAtual":"Inform the displayed Token and click on release to activate your Token",
    "MonitorOperacao":"Monitor Operation",
    "MonitorOperacaoStatus":"Status",
    "MonitorOperacaoDtEnvio":"Date of dispatch",
    "MonitorOperacaoDocumento":"Document",
    "MonitorOperacaoCliente":"Client",
    "MonitorOperacaoDtDe":"From",
    "MonitorOperacaoDtAte":"Until",
    "MonitorOperacaoOperacao":"Operation Data",
    "MonitorOperacaoValor":"Value",
    "MonitorOperacaoHistorico":"Historic",
    "MonitorOperacaoConta":"Account",
    "MonitorOperacaoAgencia":"Agency",
    "MonitorOperacaoBanco":"Bank",
    "MonitorOperacaoFavorecido":"Favored",
    "MonitorOperacaoTipo":"Type",
    "InformeLog":"Log Information",
    "Cliente":"Client",
    "ClienteNome":"Name",
    "ClienteDocumento":"Document",
    "ClienteAgencia":"Agency",
    "ClienteConta":"Account",
    "ClienteDataInclusao":"Inclusion Date",
    "ClienteValorLimite":"Limit Value",
    "ClienteCodigoConta":"Account Code",
    "ClienteToken":"Token",
    "ClienteDuplaAlcada":"Double Alcada",
    "ClienteAtivo":"Active",
    "ClienteQuantidadeAprovacao":"Approval Qty",
    "UsuarioNome":"Name",
    "UsuarioDocumento":"Document",
    "UsuarioEmail":"E-mail",
    "UsuarioAtivo":"Active",
    "UsuarioDataInclusao":"Inclusion Date",
    "UsuarioToken":"Token",
    "UsuarioBtnToken":"Release Token",
    "UsuarioTpDocumento":"Document Type",
    "UsuarioSenha":"Password",
    "UsuarioResetSenha":"Reset Password",
    "UsuarioTokenMobile":"Token Mobile",
    "PortabilidadeDoador":"You started the portability of this key ",
    "PosseDoador":"You have been asked to pass possession of this key",
    "PortabilidadeRequisitante":"You requested portability of this key",
    "PosseRequisitante":"You have requested that you can use this key",
    "UsuarioPesquisa": "User Filters",
    "PerfilContaNome":"Name",
    "PerfilContaAdm":"Administrator",
    "PerfilContaLimiteOperador":"Lt.Operator",
    "PerfilContaLimiteVLOperador":"Vlr.Operator",
    "PerfilContaLimiteAprovacao":"Lt.Aprovação",
    "PerfilContaLimiteVLAprovacao":"Vlr.Approval",
    "PerfilContaPesquisa": "Filters Perfil",
    "ConfirmarExclusaoPerfilConta":"Are you sure you want to delete profile {0}?",
    "PerfilContaFuncionalidade":"Features",
    "UsuarioCelular":"Celular",
    "LimiteTipoCliente":"Limit Tipo Cliente",
    "LimiteTipoClienteDescricao":"Description",
    "LimiteTipoClienteValor":"Value",
    "LimiteTipo":"Type Person",
    "ComprovanteTransferencia":"Transfer Receipt",
    "ComprovantePagamento":"Payment Receipt",
    "ComprovantePix":"Receipt",
    "ComprovanteTributo":"Tax Receipt",
    "OuvidoriaSAC":"SAC: sac@wooribank.com.br - 08002912214 | OMBUDSMAN: ouvidoria@wooribank.com.br - 08002912215.",
    "HorarioAtendimento":"Customer Service Hours: 10AM - 4PM.",
    "CodigoAutenticacao":"Authentication Code",
    "ErroMultiplosAcessos":"Consecutive access count limit reached. Please try again later.",
    "BloqueioSenhaMsg":"Dear user, please contact Woori Bank's Customer Service to unlock your access."
};

export const CALENDAR_EN = {
    firstDayOfWeek: 1,
    dayNames: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
    dayNamesShort: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    monthNames: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
    monthNamesShort: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
}
